module.exports = __webpack_public_path__ + "static/media/question.e4bc25de.svg";